<template lang="pug">
Page(title="Tools", :items="items")
</template>

<script>
export default {
  data() {
    return {
      items: [
        { title: "Logs", url: "/tools/logs" },
      ],
    };
  },
};
</script>
